import type { FormattedPriceSettings, TvShowEpisode } from '@setplex/tria-api'
import type { TvShowEpisodePayment } from '../interfaces'

import { MediaTypes, MediaTypesExtended } from '../index.h'
import { getPerItemPriceSettingsOnly } from './price-settings'

export const getPaymentTvChannelMediaType = (
  priceSettings: FormattedPriceSettings[]
) => {
  const perItemPriceSettings = getPerItemPriceSettingsOnly(priceSettings)

  return perItemPriceSettings && perItemPriceSettings.length > 0
    ? MediaTypes.TV_CHANNEL
    : MediaTypesExtended.TV_CHANNEL_IN_BUNDLE
}

export const getPaymentTvShowMediaType = (
  priceSettings: FormattedPriceSettings[]
) => {
  const perItemPriceSettings = getPerItemPriceSettingsOnly(priceSettings)

  return perItemPriceSettings && perItemPriceSettings.length > 0
    ? MediaTypes.TV_SHOW
    : MediaTypesExtended.TV_SHOW_IN_BUNDLE
}

export const getPaymentSeasonMediaType = (
  priceSettings: FormattedPriceSettings[]
) => {
  const perItemPriceSettings = getPerItemPriceSettingsOnly(priceSettings)

  return perItemPriceSettings && perItemPriceSettings.length > 0
    ? MediaTypesExtended.TV_SHOW_SEASON
    : MediaTypesExtended.TV_SHOW_SEASON_IN_BUNDLE
}

export const getPaymentEpisodeMediaType = (
  priceSettings: FormattedPriceSettings[]
) => {
  const perItemPriceSettings = getPerItemPriceSettingsOnly(priceSettings)

  return perItemPriceSettings && perItemPriceSettings.length > 0
    ? MediaTypesExtended.TV_SHOW_EPISODE
    : MediaTypesExtended.TV_SHOW_EPISODE_IN_BUNDLE
}

export const getPaymentTvShowEpisodeMediaType = ({
  episodePriceSettings,
  seasonPriceSettings,
  tvShowPriceSettings,
}: TvShowEpisode | TvShowEpisodePayment) => {
  if (episodePriceSettings && episodePriceSettings.length > 0) {
    return getPaymentEpisodeMediaType(episodePriceSettings)
  }

  if (seasonPriceSettings && seasonPriceSettings.length > 0) {
    return getPaymentEpisodeMediaType(seasonPriceSettings)
  }

  if (tvShowPriceSettings && tvShowPriceSettings.length > 0) {
    return getPaymentEpisodeMediaType(tvShowPriceSettings)
  }
}

export const getPaymentVodMediaType = (
  priceSettings: FormattedPriceSettings[]
) => {
  const perItemPriceSettings = getPerItemPriceSettingsOnly(priceSettings)

  return perItemPriceSettings && perItemPriceSettings.length > 0
    ? MediaTypes.VOD
    : MediaTypesExtended.VOD_IN_BUNDLE
}
